import * as _Playlists from "./users/playlists";
export { _Playlists as Playlists };
export var Paths;

(function (Paths) {
  Paths["Show"] = "/users/:userVanity";
  Paths["ListLikedVideos"] = "/users/:userVanity/likes";
  Paths["ListVideos"] = "/users/:userVanity/videos";
})(Paths || (Paths = {}));